import { useAxios } from "@hooks"
import { AIGradingAnalysis } from "@types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Hook to trigger AI analysis of an essay answer
 * @returns Mutation hook for analyzing essay with AI
 */
export const useAnalyzeWithAI = () => {
    const axios = useAxios();
    const { t } = useTranslation();
    const { message } = App.useApp();
    const queryClient = useQueryClient();

    const analyzeWithAI = async (examInstanceQuestionId: string): Promise<AIGradingAnalysis> => {
        try {
            const response = await axios.post<AIGradingAnalysis>(
                `/api/ExamInstanceQuestion/${examInstanceQuestionId}/analyze-with-ai`
            );
            return response.data;
        } catch (error: any) {
            const errorMessage = error.response?.data?.error || t("aiGrading.error");
            throw new Error(errorMessage);
        }
    };

    return useMutation({
        mutationFn: analyzeWithAI,
        onSuccess: (data, examInstanceQuestionId) => {
            // Invalidate and update the AI analysis cache
            queryClient.setQueryData(["aiAnalysis", examInstanceQuestionId], data);
            queryClient.invalidateQueries({ queryKey: ["aiAnalysis", examInstanceQuestionId] });
            message.success(t("aiGrading.analysisComplete"));
        },
        onError: (error: Error) => {
            message.error(error.message);
        }
    });
};
